import { cn } from "@nexus/ui";
import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";

import { PersonaPortrait } from "@/features/personas/components/PersonaPortrait/PersonaPortrait";
import { humanizePersonaTitle } from "@/features/personas/lib/persona-format";
import { personaDetailQueryOptions } from "@/lib/queries";

interface PersonaIdentityProps {
  id: string;
  title: string;
  tenantId: string;
  className?: string;
}

export function PersonaIdentity({
  id,
  title,
  tenantId,
  className,
}: PersonaIdentityProps) {
  const personaQuery = useQuery(personaDetailQueryOptions(tenantId, id));
  const displayTitle = humanizePersonaTitle(title);
  const avatarUrl = personaQuery.data?.avatarUrl ?? null;
  const personalityKey = personaQuery.data?.personalityKey ?? title;

  return (
    <span className={cn("flex min-w-0 items-center gap-1.5", className)}>
      <span aria-hidden className="shrink-0">
        <PersonaPortrait
          avatarUrl={avatarUrl}
          personalityKey={personalityKey}
          title={displayTitle}
          className="size-5"
          fallbackClassName="text-[9px]"
        />
      </span>
      <Link
        to="/personas"
        search={{ persona: id }}
        title={id}
        className="min-w-0 truncate font-medium text-primary hover:text-primary/80"
      >
        {displayTitle}
      </Link>
    </span>
  );
}
